import { LegacySession } from '@standardnotes/domain-core';
export class LegacySessionStorageMapper {
    toDomain(projection) {
        const { jwt } = projection;
        const legacySessionOrError = LegacySession.create(jwt);
        if (legacySessionOrError.isFailed()) {
            throw new Error(legacySessionOrError.getError());
        }
        return legacySessionOrError.getValue();
    }
    toProjection(domain) {
        return {
            jwt: domain.accessToken,
        };
    }
}
